import '../style/main.scss';
import 'bootstrap';
import Zooming from 'zooming'
import jQuery from 'jquery';
import jQueryBridget from 'jquery-bridget';
import 'jquery-ui-dist/jquery-ui.js';
import ImageViewer from 'iv-viewer';

import anime from "animejs"
//import flickity from "flickity-fade"
import flickity from "flickity-fullscreen"
import select2 from "select2"
import validate from "jquery-validation"

window.jQuery = jQuery

jQueryBridget('flickity', flickity, jQuery);

jQuery.fn.isInViewport = function (callback = null) {
  let response = false;
  if (typeof jQuery(this).offset() !== 'undefined') {
    let elementTop = jQuery(this).offset().top;
    let elementBottom = elementTop + jQuery(this).outerHeight();
    let viewportTop = jQuery(window).scrollTop();
    let viewportBottom = viewportTop + jQuery(window).height();
    response = elementBottom > viewportTop && elementTop < viewportBottom;
  }
  var status = null;
  if (callback != null) {
    if (response === true && !jQuery(this).hasClass('has-entered')) {
      jQuery(this).addClass('has-entered');
      status = 'entered';
    } else if (response === false && jQuery(this).hasClass('has-entered')) {
      jQuery(this).removeClass('has-entered');
      status = 'exited';
    }
    callback(status);
  }
  if (response) {
    jQuery(this).addClass('is-in-viewport');
  } else {
    jQuery(this).removeClass('is-in-viewport');
  }
  return response;
};
jQuery(document).ready(function ($) {

  const scrollAnimationTiming = 2000
  //navigation (scrollto) feature
  $('.nav-link[href*="#"],#scroll-down').on('click', (e) => {
    const subjectSelector = $(e.currentTarget).attr('href')
    const subject = $(document).find(subjectSelector);
    if (subject.length) {
      $([document.documentElement, document.body]).animate({
        scrollTop: subject.offset().top
      }, scrollAnimationTiming);
    }
  })

  /**
   * MODAL VIDEO
   * @type {HTMLScriptElement}
   * @see https://developers.google.com/youtube/iframe_api_reference?hl=it
   */

  $('.btn-modal-play').click(function () {
    $('#modal-player').attr('src', '../assets/video/loop.mp4');
  });

  const tag = document.createElement('script');

  tag.src = "https://www.youtube.com/iframe_api";
  const firstScriptTag = document.getElementsByTagName('script')[0];

  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  let player;
  window.onYouTubeIframeAPIReady = () => {

    player = new YT.Player('player', {
      height: '720',
      width: '1280',
      videoId: $('#modal-video #player').attr('data-ytid'),
      events: {
        'onStateChange': (event) => {
          if (event.data === YT.PlayerState.ENDED && !done) {
            //on video ended close form
            $('#modal-video').modal('hide')
          }
        }
      }
    });
  }

  let done = false;

  function playVideo() {
    player.playVideo();
  }

  function stopVideo() {
    player.stopVideo();
  }

  $('#modal-video').on('shown.bs.modal', function () {
    playVideo()
  }).on('hidden.bs.modal', function () {
    stopVideo()
  });

  //ANIMATION ON SCROLL
  /**
   * Get Percentage position of an Element from the bottom of screen
   * 0 --> near to bottom
   * 100 --> near to top
   * @param e : Element
   * @returns Number
   */
  function percentTop(e) {
    const viewportHeight = window.innerHeight;
    const scrollTop = window.scrollY;
    const elementOffsetTop = $(e).offset().top;
    const topPos = scrollTop + viewportHeight;
    const percent = Math.round(((topPos - elementOffsetTop) * 100) / viewportHeight);
    if (percent < 0) {
      return 0
    }
    if (percent > 100) {
      return 100
    }
    return percent
  }

  const anchorItemsSlider = $('.anchor-menu--items').flickity({
    freeScroll: true,
    pageDots: false,
    contain: true,
    prevNextButtons: false,
    cellAlign: 'center'
  })

  let anchorItemsSliderIsMovedByClick = false
  $('.anchor-menu--item').on('click', (e) => {
    anchorItemsSliderIsMovedByClick = true
    anchorItemsSlider.flickity('select', $(e.currentTarget).index())
    setTimeout(() => {
      anchorItemsSliderIsMovedByClick = false
    }, scrollAnimationTiming)
  })

  $(window).on('scroll', () => {
    $('.anim-show-up').each((i, e) => {
      const halfScreen = percentTop(e) * 250 / 100 // using half of the screen
      const seekValue = halfScreen / 60 //floating point conversion for AnimeJS
      const animation = anime({
        targets: e,
        opacity: [0, 1],
        translateY: ["80px", 0],
        easing: 'easeInOutSine',
        autoplay: false
      })
      animation.seek(animation.duration * seekValue) //  (@see https://animejs.com/documentation/#seekAnim)
    })
    $('.anchor-menu--items').find('.anchor-menu--item').each((i, a) => {
      if ($($(a).attr('href')).isInViewport()) {
        $(a).addClass('active');

        if (!anchorItemsSliderIsMovedByClick) {
          anchorItemsSlider.flickity('select', i)
        }
      } else {
        $(a).removeClass('active');
      }
      //POSTFIX
      if ($('.anchor-menu--items').find('.anchor-menu--item.active').length > 1) {
        $('.anchor-menu--items').find('.anchor-menu--item.active').not(':last').removeClass('active')
      }
    });
  })

  // SCROLL TO
  //navigation (scrollto) feature
  $('a[href*="#"]').on('click', (e) => {
    const subjectSelector = $(e.currentTarget).attr('href')
    const subject = $(document).find(subjectSelector);
    if (subject.length) {
      $([document.documentElement, document.body]).animate({
        scrollTop: subject.offset().top
      }, 2000);
    }
  })

  // CTA mobile - Add <br> tag dynamically on vw resize
  $(window).resize(function () {
    let vw = $(this).innerWidth();
    let ctaBrAmount = $('.presentation--cta-1 span br, .presentation--cta-2 span br, .presentation--images .cucina-zen .append-br br').length;

    if (vw < 576 && ctaBrAmount < 1) {
      var cta_1_text = $('.presentation--cta-1 span');
      var cta_2_text = $('.presentation--cta-2 span');

      $(cta_1_text).append('<br>');
      $(cta_2_text).append('<br>');
      $('.append-br').append('<br>')
    }

    if (vw >= 576) {
      $('.presentation--cta-1 span br').remove();
      $('.presentation--cta-2 span br').remove();
      $('.presentation--images .cucina-zen .append-br br').remove();
    }

    // Delete <br> tag from #intro-text under (992px) dynamically on vw resize
    if (vw > 992) {
      if (!$('#intro-text p').find('br.intro-br').length) {
        $('#intro-text p span.intro-span').append('<br class="intro-br">');
      }
    } else {
      $('#intro-text p br.intro-br').remove();
    }
  });

  //CTA mobile - Add <br> tag statically on start page
  $(window).width(function () {
    let vw = $(this).innerWidth();
    let ctaBrAmount = $('.presentation--cta-1 span br, .presentation--cta-2 span br, .presentation--images .cucina-zen .append-br br').length;

    if (vw < 576 && ctaBrAmount < 1) {
      var cta_1_text = $('.presentation--cta-1 span');
      var cta_2_text = $('.presentation--cta-2 span');

      $(cta_1_text).append('<br>');
      $(cta_2_text).append('<br>');
      $('.append-br').append('<br>')
    }

    if (vw >= 576) {
      $('.presentation--cta-1 span br').remove();
      $('.presentation--cta-2 span br').remove();
      $('.presentation--images .cucina-zen .append-br br').remove();
    }

    // Delete <br> tag from intro-text under (992px)
    if (vw > 992) {
      if (!$('#intro-text p').find('br.intro-br').length) {
        $('#intro-text p span.intro-span').append('<br class="intro-br">');
      }
    } else {
      $('#intro-text p br.intro-br').remove();
    }
  });
});

